import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

import './configuracaoSistema.css';

function parseBoolConfig(val, defaultValue) {
    if (val == null) return defaultValue;
    if (typeof val === 'boolean') return val;
    if (typeof val === 'number') return val === 1;
    const s = String(val).trim().toLowerCase();
    if (s === '1' || s === 'true' || s === 's') return true;
    if (s === '0' || s === 'false' || s === 'n') return false;
    return defaultValue;
}

function ConfiguracaoSistema(props) {

    const history = useHistory();

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [ipServidor, setIpServidor] = useState('');
    const [porta, setPorta] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [usaTls, setUsaTls] = useState(true);
    const [sslImplicito, setSslImplicito] = useState(false);

    const [textoAbertura, setTextoAbertura] = useState('');
    const [assuntoAbertura, setAssuntoAbertura] = useState('');

    const [textoTramite, setTextoTramite] = useState('');
    const [assuntoTramite, setAssuntoTramite] = useState('');

    const [textoFinalizacao, setTextoFinalizacao] = useState('');
    const [assuntoFinalizacao, setAssuntoFinalizacao] = useState('');

    const [textoComentario, setTextoComentario] = useState('');
    const [assuntoComentario, setAssuntoComentario] = useState('');

    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('');
    const [configExiste, setConfigExiste] = useState(false);
    const [salvando, setSalvando] = useState(false);
    const [variaveisTemplate, setVariaveisTemplate] = useState([]);
    const [, setStatusDisponiveis] = useState([]);
    const [etapasSelecionadas, setEtapasSelecionadas] = useState({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
    const [, setSalvandoEtapas] = useState(false);

    const verificarCampos = () => {
        if (ipServidor.trim() === '') {
            setMensagem('Informe o IP ou host do servidor SMTP.');
            return false;
        }
        if (porta.trim() === '') {
            setMensagem('Informe a porta do servidor SMTP.');
            return false;
        }
        if (email.trim() === '') {
            setMensagem('Informe o endereço de e-mail.');
            return false;
        }
        if (!configExiste && senha.trim() === '') {
            setMensagem('Informe a senha do e-mail na primeira configuração.');
            return false;
        }
        setMensagem('');
        return true;
    };

    useEffect(() => {
        verificar();
        buscandoConfiguracao();
        buscandoVariaveis();
        buscarStatusChamado();
        buscarEtapasChamado();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const buscandoVariaveis = async () => {
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/email/variaveis', {
                headers: { Authorization: `${token}` }
            });
            if (Array.isArray(response.data)) setVariaveisTemplate(response.data);
        } catch (_) {
            setVariaveisTemplate([
                { variavel: '{{satnum}}', descricao: 'Número do chamado' },
                { variavel: '{{nomsol}}', descricao: 'Nome do solicitante' },
                { variavel: '{{nomcol}}', descricao: 'Nome do colaborador/atendente' },
                { variavel: '{{nomusu}}', descricao: 'Nome do usuário que escreveu (ex.: autor do comentário)' },
                { variavel: '{{data}}', descricao: 'Data/hora do último trâmite' },
                { variavel: '{{descricao}}', descricao: 'Última descrição/trâmite' },
                { variavel: '{{descAbre}}', descricao: 'Início da descrição da abertura (até 40 caracteres)' }
            ]);
        }
    };

    const buscandoConfiguracao = async () => {

        verificar();
        verificandoToken();

        try {

            const token = localStorage.getItem('token');

            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/email", {
                headers: {
                    Authorization: `${token}`
                }
            });

            const lista = Array.isArray(response.data) ? response.data : [];
            if (lista.length === 0) {
                setConfigExiste(false);
                return;
            }

            setConfigExiste(true);
            const cfg = lista[0];
            setIpServidor(cfg.ipservidor || cfg.ipServidor || '');
            setPorta(cfg.porta != null ? String(cfg.porta) : '');
            setEmail(cfg.email || '');
            setUsaTls(parseBoolConfig(cfg.usa_tls ?? cfg.usaTls, true));
            setSslImplicito(parseBoolConfig(cfg.ssl_implicito ?? cfg.sslImplicito, false));
            setAssuntoAbertura(cfg.assuntoAbertura || '');
            setTextoAbertura(cfg.textoAbertura || '');
            setAssuntoFinalizacao(cfg.assuntoFinalizacao || '');
            setTextoFinalizacao(cfg.textoFinalizacao || '');
            setAssuntoTramite(cfg.assuntoTramite || '');
            setTextoTramite(cfg.textoTramite || '');
            setTextoComentario(cfg.textoComentario || '');
            setAssuntoComentario(cfg.assuntoComentario || '');

        } catch (error) {
            if (error?.response?.status === 404) {
                setConfigExiste(false);
            } else {
                console.error('Erro ao buscar dados:', error);
            }
        }
    };

    const alterandoconfiguracao = async () => {
        if (!verificarCampos()) return;

        verificandoToken();
        setSalvando(true);
        setSucesso('');

        const token = localStorage.getItem('token');

        try {
            await axios.put(
                ensureProtocol(localStorage.getItem("ipBackend2")) + "/email",
                {
                    ipServidor,
                    porta,
                    email,
                    senha: senha.trim() || undefined,
                    usaTls,
                    sslImplicito,
                    textoAbertura,
                    textoTramite,
                    textoFinalizacao,
                    textoComentario,
                    assuntoAbertura,
                    assuntoTramite,
                    assuntoFinalizacao,
                    assuntoComentario
                },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                }
            );

            setConfigExiste(true);
            setSenha('');
            setMensagem('');
            setSucesso('Configuração de e-mail salva com sucesso.');
        } catch (error) {
            setSucesso('');
            setMensagem(error?.response?.data?.error || 'Erro ao salvar a configuração de e-mail.');
        } finally {
            setSalvando(false);
        }
    };

    const buscarStatusChamado = async () => {
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/status-chamado', {
                headers: { Authorization: `${token}` }
            });
            const lista = Array.isArray(response.data) ? response.data : [];
            const normalizada = lista.map((s) => ({
                id: s.id ?? s.ID ?? s.codigo_legado,
                codigo_legado: s.codigo_legado ?? s.CODIGO_LEGADO ?? s.codigo ?? s.CODIGO,
                nome: s.nome ?? s.NOME ?? String(s.codigo_legado ?? s.CODIGO_LEGADO ?? '')
            })).filter((s) => s.codigo_legado != null && s.nome);
            setStatusDisponiveis(normalizada);
        } catch (err) {
            console.error('Erro ao buscar status de chamado para configuração de etapas:', err);
            setStatusDisponiveis([]);
        }
    };

    const buscarEtapasChamado = async () => {
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const empresaId = localStorage.getItem('empresaId') || localStorage.getItem('empresa_id') || '';
            if (!empresaId) return;
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + `/empresas/${empresaId}/etapas-chamado`, {
                headers: { Authorization: `${token}` }
            });
            const etapas = (response.data && response.data.etapas) || {};
            setEtapasSelecionadas({
                SUPORTE: Array.isArray(etapas.SUPORTE) ? etapas.SUPORTE : [],
                ANALISE: Array.isArray(etapas.ANALISE) ? etapas.ANALISE : [],
                DESENVOLVIMENTO: Array.isArray(etapas.DESENVOLVIMENTO) ? etapas.DESENVOLVIMENTO : [],
                EM_TESTE: Array.isArray(etapas.EM_TESTE) ? etapas.EM_TESTE : [],
            });
        } catch (err) {
            console.error('Erro ao buscar etapas do chamado:', err);
            setEtapasSelecionadas({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
        }
    };

    // eslint-disable-next-line no-unused-vars -- reservado para UI de etapas do chamado
    const toggleEtapaStatus = (tipo, codigoLegado) => {
        setEtapasSelecionadas((prev) => {
            const atual = Array.isArray(prev[tipo]) ? prev[tipo] : [];
            const cod = typeof codigoLegado === 'number' ? codigoLegado : parseInt(String(codigoLegado), 10);
            if (Number.isNaN(cod)) return prev;
            const jaTem = atual.includes(cod);
            const novo = jaTem ? atual.filter((c) => c !== cod) : [...atual, cod];
            return { ...prev, [tipo]: novo };
        });
    };

    // eslint-disable-next-line no-unused-vars -- reservado para UI de etapas do chamado
    const salvarEtapasChamado = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        const empresaId = localStorage.getItem('empresaId') || localStorage.getItem('empresa_id') || '';
        if (!empresaId) {
            alert('Empresa não identificada para salvar as etapas do chamado.');
            return;
        }
        setSalvandoEtapas(true);
        try {
            await axios.put(
                ensureProtocol(localStorage.getItem('ipBackend2')) + `/empresas/${empresaId}/etapas-chamado`,
                { etapas: etapasSelecionadas },
                { headers: { Authorization: `${token}` } }
            );
        } catch (err) {
            console.error('Erro ao salvar etapas do chamado:', err);
            alert(err.response?.data?.error || 'Erro ao salvar as etapas do chamado. Verifique se os scripts do banco estão atualizados.');
        } finally {
            setSalvandoEtapas(false);
        }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo">
                <div className="page-header config-page-header">
                    <div className="config-header-row">
                        <h1>Configurações do sistema</h1>
                        <Link to="/permissoes-usuario" className="btn btn-outline-primary config-btn-permissoes">
                            <i className="fas fa-user-lock" aria-hidden="true" /> Permissões do menu por usuário
                        </Link>
                    </div>
                </div>
                {variaveisTemplate.length > 0 && (
                    <div className="alert alert-info config-variaveis-box">
                        <strong>Variáveis para montagem das mensagens</strong> (use nos textos e assuntos; serão substituídas no envio):
                        <ul className="config-variaveis-lista mb-0 mt-2">
                            {variaveisTemplate.map((v, idx) => (
                                <li key={idx}><code>{v.variavel}</code> — {v.descricao}</li>
                            ))}
                        </ul>
                    </div>
                )}
            <h2 className="mt-3">Configuração de envio de e-mail</h2>
            <form>
                <div className="form-group mb-1">
                    <label htmlFor="config-email-servidor">IP do Servidor</label>
                    <input type="text" onChange={(e) => setIpServidor(e.target.value)} value={ipServidor} className="form-control" id="config-email-servidor" placeholder="smtp.exemplo.com" />
                </div>
                <div className="form-group mb-1">
                    <label htmlFor="config-email-porta">Porta</label>
                    <input type="number" onChange={(e) => setPorta(e.target.value)} value={porta} className="form-control" id="config-email-porta" placeholder="587" />
                </div>
                <div className="form-group mb-1">
                    <label htmlFor="config-email-endereco">Endereço de email</label>
                    <input type="email" onChange={(e) => setEmail(e.target.value)} value={email} className="form-control" id="config-email-endereco" placeholder="email" />
                </div>
                <div className="form-group mb-1">
                    <label htmlFor="config-email-senha">Senha</label>
                    <input type="password" onChange={(e) => setSenha(e.target.value)} value={senha} className="form-control" id="config-email-senha" placeholder={configExiste ? 'Deixe em branco para manter a senha atual' : 'Senha do e-mail (obrigatória na primeira configuração)'} />
                </div>
                <div className="form-group mb-2">
                    <label className="d-flex align-items-center gap-2 mb-1">
                        <input type="checkbox" checked={usaTls} onChange={(e) => setUsaTls(e.target.checked)} />
                        Usar TLS (STARTTLS)
                    </label>
                    <small className="text-muted d-block">Recomendado para porta 587 (Office 365, Gmail, etc.). Desmarque apenas se o servidor SMTP for legado sem criptografia.</small>
                </div>
                <div className="form-group mb-3">
                    <label className="d-flex align-items-center gap-2 mb-1">
                        <input type="checkbox" checked={sslImplicito} onChange={(e) => setSslImplicito(e.target.checked)} />
                        SSL implícito (porta 465)
                    </label>
                    <small className="text-muted d-block">Marque se o servidor exige conexão SSL direta, típico da porta 465.</small>
                </div>

                <h6 className="mt-3">Abertura</h6>
                <hr></hr>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Assunto</label>
                    <input type="email" onChange={(e) => setAssuntoAbertura(e.target.value)} value={assuntoAbertura} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Assunto Abertura " />
                </div>
                <div className="form-group">
                    <label for="exampleFormControlTextarea1">Texto E-mail</label>
                    <textarea onChange={(e) => setTextoAbertura(e.target.value)} value={textoAbertura} className="form-control" id="exampleFormControlTextarea1" rows="10"></textarea>
                </div>

                <h6 className="mt-3">Tramite</h6>
                <hr></hr>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Assunto</label>
                    <input type="email" onChange={(e) => setAssuntoTramite(e.target.value)} value={assuntoTramite} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Assunto Tramite " />
                </div>
                <div className="form-group">
                    <label for="exampleFormControlTextarea1">Texto E-mail</label>
                    <textarea onChange={(e) => setTextoTramite(e.target.value)} value={textoTramite} className="form-control" id="exampleFormControlTextarea1" rows="10"></textarea>
                </div>

                <h6 className="mt-3">Finalização</h6>
                <hr></hr>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Assunto</label>
                    <input type="email" onChange={(e) => setAssuntoFinalizacao(e.target.value)} value={assuntoFinalizacao} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Assunto Finalização " />
                </div>
                <div className="form-group">
                    <label for="exampleFormControlTextarea1">Texto E-mail</label>
                    <textarea onChange={(e) => setTextoFinalizacao(e.target.value)} value={textoFinalizacao} className="form-control" id="exampleFormControlTextarea1" rows="10"></textarea>
                </div>

                <h6 className="mt-3">Comentário (não interno)</h6>
                <hr></hr>
                <p className="text-muted small">Enviado ao solicitante quando um comentário não interno é adicionado ao chamado. O sistema também exibe notificação ao usuário.</p>
                <div className="form-group mb-1">
                    <label>Assunto</label>
                    <input type="text" onChange={(e) => setAssuntoComentario(e.target.value)} value={assuntoComentario} className="form-control" placeholder="Assunto comentário" />
                </div>
                <div className="form-group">
                    <label>Texto E-mail</label>
                    <textarea onChange={(e) => setTextoComentario(e.target.value)} value={textoComentario} className="form-control" rows="6" placeholder="Corpo do e-mail de comentário"></textarea>
                </div>

                <button onClick={alterandoconfiguracao} type="button" className="btn btn-secondary btn-acao mt-4" disabled={salvando}>
                    {salvando ? 'Salvando...' : 'Salvar'}
                </button>
            </form>

            {sucesso ? <div className="alert alert-success mt-2" role="alert">{sucesso}</div> : null}
            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}

            </div>
            </main>
        </div>
    );
}

export default ConfiguracaoSistema;
